export const ES = () => {
  return (
    <>
      <g clipPath="url(#clip0_1073_15752)">
      <g clipPath="url(#clip1_1073_15752)">
      <rect x="96" y="72" width="96" height="48" transform="rotate(180 96 72)" fill="#EFD444"/>
      <rect x="96" y="96" width="96" height="24" transform="rotate(180 96 96)" fill="#EF4444"/>
      <rect x="96" y="24" width="96" height="24" transform="rotate(180 96 24)" fill="#EF4444"/>
      <circle cx="48" cy="48" r="12" fill="#EF4444"/>
      </g>
      </g>
      <rect x="2" y="2" width="92" height="92" rx="46" stroke="white" strokeOpacity="0.15" strokeWidth="4"/>
      <defs>
      <clipPath id="clip0_1073_15752">
      <rect width="96" height="96" rx="48" fill="white"/>
      </clipPath>
      <clipPath id="clip1_1073_15752">
      <rect width="96" height="96" rx="24" fill="white"/>
      </clipPath>
      </defs>
    </>
  )
}
